import { NAVIGATION_LINKS } from "../../constants/common"

export const DESKTOP_NAVIGATION = [
    {
        header: "About us",
    },
    {
        header: "Services",
        section: "services",
        items: [
            {
                title: "Team Augmentation",
                text: "Extend your team quickly with our technical talents. Our software developers possess extensive cross-industry expertise and can help you build powerful products and drive your business growth.",
                link: NAVIGATION_LINKS.TEAM_AUGMENTATION,
            },
            {
                title: "IT Consulting & Advisory",
                text: "Our senior engineering experts assess your current business state and build a technology strategy to help improve the performance, scalability and competitiveness of your company growth.",
                link: NAVIGATION_LINKS.IT_CONSULTING_AND_ADVISORY,
            }
        ],
    },
    {
        header: "Cases",
        section: "cases",
        items: [
            {
                title: "TryNow",
                text: "Developed e-commerce solutions from scratch.",
                link: NAVIGATION_LINKS.TRYNOW

            },
            {
                title: "Quarkworks",
                text: "Developed 4 powerful products for a budding startup.",
                link: NAVIGATION_LINKS.QUARKWORKS

            },
            {
                title: "Orbit",
                text: "Developed recruitment platform for freelance recruiters.",
                link: NAVIGATION_LINKS.ORBIT

            },
            {
                title: "Hello | project of ex-Google Engineers",
                text: "Social media app where you can set your interests in the application, build your own communities and chat with people.",
                link: NAVIGATION_LINKS.HELLO

            }, 
            {
                title: "Craft | B2B project",
                text: "SaaS analytics platform for businesses where the user can quickly analyze all the data on earnings, expenses, and the site from his Excel sheet, and was promptly provided with a comprehensive analysis accompanied by graphs. ",
                link: NAVIGATION_LINKS.CRAFT

            },
            {
                title: "PedNet | project for improving  the Well-being of Colombian Residents",
                text: "Mobile application for Android and iOS that allows people to interact with local authorities in America and report problems related to road safety, pedestrians, and cyclists. ",
                link: NAVIGATION_LINKS.PEDNET

            }
        ],
    },
]
